'use client'

import { useLocale } from 'next-intl'
import { Direction } from 'radix-ui'

export const DirectionProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const locale = useLocale()
  const dir = locale === 'ar' ? 'rtl' : 'ltr'

  return <Direction.Provider dir={dir}>{children}</Direction.Provider>
}
